module.exports = __webpack_public_path__ + "static/media/icon_openall_arrow_down.c7f4f986.svg";